import { render, staticRenderFns } from "./LaudoImprimirLaudos.vue?vue&type=template&id=38c57aa8&"
import script from "./LaudoImprimirLaudos.vue?vue&type=script&lang=js&"
export * from "./LaudoImprimirLaudos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports